﻿export interface AppConfig {
    apiBaseUrl: string,
    surveyPublicUrl: string,
    municipalityId: number,
    gpsx: number,
    gpsy: number
}

export const config: AppConfig = window['config']

export let BASECONFIG = {
    //apiUrl: 'http://212.39.124.120:8095/zepce/webApi',
    //apiUrl: 'http://10.43.0.251:8095/capljina/webApi',
    apiUrl: config.apiBaseUrl,
    //municipalityId: 16
    municipalityId: config.municipalityId
};

export let CONFIG = {
    //surveyPublicUrl: 'http://localhost:5002/survey/fill-survey/survey-details/',
    surveyPublicUrl: config.surveyPublicUrl,
    coordinates: {
        gpsx: config.gpsx,
        gpsy: config.gpsy
    },
    baseUrls: {
        nav: {
            getNavMenu: BASECONFIG.apiUrl + '/api/MenuItem/GetAll/'
        },
        admin: {
            users: {
                getAll: BASECONFIG.apiUrl + '/api/Users/GetAll/',
                getAllActiveUsers: BASECONFIG.apiUrl + '/api/Users/GetAllActiveUsers/',
                getByID: BASECONFIG.apiUrl + '/api/Users/GetByID/',
                save: BASECONFIG.apiUrl + '/api/Users/Save',
                changePassword: BASECONFIG.apiUrl + '/api/Users/ChangePassword',
                searchUsers: BASECONFIG.apiUrl + '/api/Users/SearchUsers',
                getAllUsersEmails: BASECONFIG.apiUrl + '/api/Users/GetAllUsersEmails/',
                getAllUsersTelephoneNumbers: BASECONFIG.apiUrl + '/api/Users/GetAllUsersTelephoneNumbers/',
                getAllUsersDevices: BASECONFIG.apiUrl + '/api/Users/GetAllUsersDevices/',
                getAllUsersEmailsToSelectAll: BASECONFIG.apiUrl + '/api/Users/GetAllUsersEmailsToSelectAll/',
                getAllUsersTelephoneNumbersToSelectAll: BASECONFIG.apiUrl + '/api/Users/GetAllUsersTelephoneNumbersToSelectAll/',
                getAllUsersDevicesToSelectAll: BASECONFIG.apiUrl + '/api/Users/GetAllUsersDevicesToSelectAll/',
                deleteUserByID: BASECONFIG.apiUrl + '/api/Users/DeleteUserByID/'
            },
            offlineDebates: {
                searchofflineDebates: BASECONFIG.apiUrl + '/api/OfflineDebates/SearchOfflineDebates',
                getOfflineDebateById: BASECONFIG.apiUrl + '/api/OfflineDebates/GetByID/',
                saveOfflineDebate: BASECONFIG.apiUrl + '/api/OfflineDebates/Save',
                downloadOfflineDebateFile: BASECONFIG.apiUrl + '/api/OfflineDebates/DownloadFile',
                deleteOfflineDebate: BASECONFIG.apiUrl + '/api/OfflineDebates/DeleteOfflineDebate/'
            },
            offlineDebateSessions: {
                getOfflineDebateSessions: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/GetOfflineDebateSessions',
                getOfflineDebateSessionById: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/GetByID/',
                saveOfflineDebateSession: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/Save',
                downloadOfflineDebateSessionFile: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/DownloadFile',
                sendOfflineDebateSessionFinalReport: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/SendFinalReport',
                downloadOfflineDebateSessionFinalReport: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/DownloadFinalReport',
                getOfflineDebateSessionSendFinalReportById: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/GetOfflineDebateSessionSendFinalReportByID/',
                deleteOfflineDebateSession: BASECONFIG.apiUrl + '/api/OfflineDebateSessions/DeleteOfflineDebateSession/'
            },
            onlineDebates: {
                searchOnlineDebates: BASECONFIG.apiUrl + '/api/OnlineDebates/SearchOnlineDebates',
                getOnlineDebateById: BASECONFIG.apiUrl + '/api/OnlineDebates/GetByID/',
                saveOnlineDebate: BASECONFIG.apiUrl + '/api/OnlineDebates/Save',
                downloadOnlineDebateFile: BASECONFIG.apiUrl + '/api/OnlineDebates/DownloadFile',
                onlineDebateLinkSearchComplaints: BASECONFIG.apiUrl + '/api/OnlineDebates/SearchLinkComplaints/',
                onlineDebateLinkSearchSessionAgenda: BASECONFIG.apiUrl + '/api/OnlineDebates/SearchLinkSessionAgenda/',
                deleteOnlineDebate: BASECONFIG.apiUrl + '/api/OnlineDebates/DeleteOnlineDebate/'
            },
            onlineDebateDiscussions: {
                getOnlineDebateDiscussions: BASECONFIG.apiUrl + '/api/OnlineDebateDiscussions/GetOnlineDebateDiscussions',
                getOnlineDebateDiscussionById: BASECONFIG.apiUrl + '/api/OnlineDebateDiscussions/GetByID/',
                saveOnlineDebateDiscussion: BASECONFIG.apiUrl + '/api/OnlineDebateDiscussions/Save',
                downloadOnlineDebateDiscussionCommentFile: BASECONFIG.apiUrl + '/api/OnlineDebateDiscussions/DownloadOnlineDebateDiscussionCommentFile',
                deleteOnlineDebateDiscussion: BASECONFIG.apiUrl + '/api/OnlineDebateDiscussions/DeleteOnlineDebateDiscussion/'
            },
            debates: {
                getDebateById: BASECONFIG.apiUrl + '/api/Debates/GetByID/'
            },
            RESTServiceUsers: {
                getAll: BASECONFIG.apiUrl + '/api/RESTServiceUsers/GetAll',
                getByID: BASECONFIG.apiUrl + '/api/RESTServiceUsers/GetByID/',
                save: BASECONFIG.apiUrl + '/api/RESTServiceUsers/Save',
                changePassword: BASECONFIG.apiUrl + '/api/RESTServiceUsers/ChangePassword',
                deleteUserByID: BASECONFIG.apiUrl + '/api/RESTServiceUsers/DeleteUserByID/',
            },
            systemParameters: {
                getAllConfirmationRegistrationTypes: BASECONFIG.apiUrl + '/api/SystemParameters/GetAllConfirmationRegistrationType/',
                saveConfirmationRegistrationTypeActivity: BASECONFIG.apiUrl + '/api/SystemParameters/SaveConfirmationRegistrationTypeActivity',
                getAllLoginTypes: BASECONFIG.apiUrl + '/api/SystemParameters/GetAllLoginType/',
                saveLoginTypeActivity: BASECONFIG.apiUrl + '/api/SystemParameters/SaveLoginTypeActivity',
                getAllRegistrationFields: BASECONFIG.apiUrl + '/api/SystemParameters/GetAllRegistrationFields/',
                saveRegistrationFields: BASECONFIG.apiUrl + '/api/SystemParameters/SaveRegistrationFields',
                getAllComplaintParameters: BASECONFIG.apiUrl + '/api/SystemParameters/GetAllComplaintParameters/',
                GetComplaintParameterByID: BASECONFIG.apiUrl + '/api/SystemParameters/GetComplaintParameterByID/',
                SaveConfigurationParameter: BASECONFIG.apiUrl + '/api/SystemParameters/SaveComplaintParameter/',
            },
            infoSection: {
                getAllTexts: BASECONFIG.apiUrl + '/api/AdminInfoSectionText/GetAll/',
                getTextByID: BASECONFIG.apiUrl + '/api/AdminInfoSectionText/GetByID/',
                saveText: BASECONFIG.apiUrl + '/api/AdminInfoSectionText/Save',
                deleteTextByID: BASECONFIG.apiUrl + '/api/AdminInfoSectionText/DeleteByID/',
                getAllDocuments: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocument/GetAll/',
                getDocumentByID: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocument/GetByID/',
                saveDocument: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocument/Save',
                uploadDocument: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocument/Upload',
                deleteDocumentByID: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocument/DeleteByID/'
            },
            globalCodes: {
                getQuestionsByOrganizationalUnitID: BASECONFIG.apiUrl + '/api/OrganizationalUnit/getQuestionsByOrganizationalUnitID',
                getAllOrganizationalUnits: BASECONFIG.apiUrl + '/api/OrganizationalUnit/GetAll/',
                getAllOrganizationalUnitsByParentID: BASECONFIG.apiUrl + '/api/OrganizationalUnit/GetAllByParentId',
                getOrganizationalUnitByID: BASECONFIG.apiUrl + '/api/OrganizationalUnit/GetByID/',
                saveOrganizationalUnit: BASECONFIG.apiUrl + '/api/OrganizationalUnit/Save',
                deleteOrganizationalUnitByID: BASECONFIG.apiUrl + '/api/OrganizationalUnit/DeleteOrganizationalUnitByID/',
                getAllOrganizationalUnitFunctions: BASECONFIG.apiUrl + '/api/OrganizationalUnitFunction/GetAll/',
                getOrganizationalUnitFunctionByID: BASECONFIG.apiUrl + '/api/OrganizationalUnitFunction/GetByID/',
                saveOrganizationalUnitFunction: BASECONFIG.apiUrl + '/api/OrganizationalUnitFunction/Save',
                deleteOrganizationalUnitFunctionByID: BASECONFIG.apiUrl + '/api/OrganizationalUnitFunction/DeleteOrganizationalUnitFunctionByID/',
                getAllCategories: BASECONFIG.apiUrl + '/api/Category/GetAll/',
                getCategoryByID: BASECONFIG.apiUrl + '/api/Category/GetByID/',
                saveCategory: BASECONFIG.apiUrl + '/api/Category/Save',
                getIcons: BASECONFIG.apiUrl + '/api/Category/GetIcons/',
                deleteCategoryByID: BASECONFIG.apiUrl + '/api/Category/DeleteCategoryByID/',
                getAllSensitiveCategories: BASECONFIG.apiUrl + '/api/SensitiveCategory/GetAll/',
                getSensitiveCategoryByID: BASECONFIG.apiUrl + '/api/SensitiveCategory/GetByID/',
                saveSensitiveCategory: BASECONFIG.apiUrl + '/api/SensitiveCategory/Save',
                deleteSensitiveCategoryByID: BASECONFIG.apiUrl + '/api/SensitiveCategory/DeleteSensitiveCategoryByID/',
                getAllDocumentTypes: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocumentType/GetAll/',
                getDocumentTypeByID: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocumentType/GetByID/',
                saveDocumentType: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocumentType/Save',
                deleteDocumentTypeByID: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocumentType/DeleteDocumentTypeByID/',
                getAllProfileTypes: BASECONFIG.apiUrl + '/api/ProfileType/GetAll/',
                getProfileTypeByID: BASECONFIG.apiUrl + '/api/ProfileType/GetByID/',
                saveProfileType: BASECONFIG.apiUrl + '/api/ProfileType/Save',
                getAllDebateSessionTypes: BASECONFIG.apiUrl + '/api/DebateSessionType/GetAll/',
                getDebateSessionTypeByID: BASECONFIG.apiUrl + '/api/DebateSessionType/GetByID/',
                saveDebateSessionType: BASECONFIG.apiUrl + '/api/DebateSessionType/Save',
                deleteDebateSessionTypeByID: BASECONFIG.apiUrl + '/api/DebateSessionType/DeleteDebateSessionTypeByID/',
                getAllDebateCategorys: BASECONFIG.apiUrl + '/api/DebateCategory/GetAll/',
                getDebateCategoryByID: BASECONFIG.apiUrl + '/api/DebateCategory/GetByID/',
                saveDebateCategory: BASECONFIG.apiUrl + '/api/DebateCategory/Save',
                deleteDebateCategoryByID: BASECONFIG.apiUrl + '/api/DebateCategory/DeleteDebateCategoryByID/',
                searchPersons: BASECONFIG.apiUrl + '/api/Person/Search/',
                getPersonByID: BASECONFIG.apiUrl + '/api/Person/GetByID/',
                savePerson: BASECONFIG.apiUrl + '/api/Person/Save',
                deletePersonByID: BASECONFIG.apiUrl + '/api/Person/DeletePersonByID/',
                getAllConvocations: BASECONFIG.apiUrl + '/api/Convocation/GetAll/',
                getConvocationByID: BASECONFIG.apiUrl + '/api/Convocation/GetByID/',
                saveConvocation: BASECONFIG.apiUrl + '/api/Convocation/Save',
                deleteConvocationByID: BASECONFIG.apiUrl + '/api/Convocation/DeleteConvocationByID/',
                getAllPoliticalParties: BASECONFIG.apiUrl + '/api/PoliticalParty/GetAll/',
                getPoliticalPartyByID: BASECONFIG.apiUrl + '/api/PoliticalParty/GetByID/',
                savePoliticalParty: BASECONFIG.apiUrl + '/api/PoliticalParty/Save',
                deletePoliticalPartyByID: BASECONFIG.apiUrl + '/api/PoliticalParty/DeletePoliticalPartyByID/',
                getAllLegalRemedies: BASECONFIG.apiUrl + '/api/LegalRemedy/GetAll/',
                getLegalRemedyByID: BASECONFIG.apiUrl + '/api/LegalRemedy/GetByID/',
                saveLegalRemedy: BASECONFIG.apiUrl + '/api/LegalRemedy/Save',
                deleteLegalRemedy: BASECONFIG.apiUrl + '/api/LegalRemedy/DeleteLegalRemedyByID/',
                getAllAdministrativeProcedureCategoriesByParentID: BASECONFIG.apiUrl + '/api/AdministrativeProcedureCategory/GetAllByParentId',
                getAdministrativeProcedureCategoriesByID: BASECONFIG.apiUrl + '/api/AdministrativeProcedureCategory/GetById/',
                saveAmdProcedureCategoryByID: BASECONFIG.apiUrl + '/api/AdministrativeProcedureCategory/Save',
                deleteAmdProcedureCategoryByID: BASECONFIG.apiUrl + '/api/AdministrativeProcedureCategory/DeleteCategoryByID/',
                survey: {
                    //type
                    getAllSurveyTypes: BASECONFIG.apiUrl + '/api/SurveyType/GetAll/',
                    getSurveyTypeByID: BASECONFIG.apiUrl + '/api/SurveyType/GetByID/',
                    saveSurveyType: BASECONFIG.apiUrl + '/api/SurveyType/Save',
                    deleteSurveyTypeByID: BASECONFIG.apiUrl + '/api/SurveyType/DeleteSurveyTypeByID/',
                    getAllSurveyParticipantTypes: BASECONFIG.apiUrl + '/api/SurveyParticipantType/GetAll/',
                    getSurveyParticipantTypeByID: BASECONFIG.apiUrl + '/api/SurveyParticipantType/GetByID/',
                    saveSurveyParticipantType: BASECONFIG.apiUrl + '/api/SurveyparticipantType/Save',
                    deleteSurveyParticipantTypeByID: BASECONFIG.apiUrl + '/api/SurveyParticipantType/DeleteSurveyParticipantTypeByID/',


                    //category
                    getAllSurveyCategories: BASECONFIG.apiUrl + '/api/SurveyCategory/GetAll/',
                    getSurveyCategoryByID: BASECONFIG.apiUrl + '/api/SurveyCategory/GetByID/',
                    saveSurveyCategory: BASECONFIG.apiUrl + '/api/SurveyCategory/Save',
                    deleteSurveyCategoryByID: BASECONFIG.apiUrl + '/api/SurveyCategory/DeleteSurveyCategoryByID/',
                    //status
                    getAllSurveyStatuses: BASECONFIG.apiUrl + '/api/SurveyStatus/GetAll/',
                    getSurveyStatusByID: BASECONFIG.apiUrl + '/api/SurveyStatus/GetByID/',
                    saveSurveyStatus: BASECONFIG.apiUrl + '/api/SurveyStatus/Save',
                    deleteSurveyStatusByID: BASECONFIG.apiUrl + '/api/SurveyStatus/DeleteSurveyStatusByID/',
                }
            },
            systemNotification: {
                getAllSystemNotification: BASECONFIG.apiUrl + '/api/SystemNotification/GetAll/',
                getSystemNotificationByID: BASECONFIG.apiUrl + '/api/SystemNotification/GetByID/',
                saveSystemNotification: BASECONFIG.apiUrl + '/api/SystemNotification/EditSystemNotification/',
                getRecipientsBySystemNotificationID: BASECONFIG.apiUrl + '/api/SystemNotification/GetRecipientsBySystemNotificationID',
                searchUsersForSystemNotifications: BASECONFIG.apiUrl + '/api/SystemNotification/SearchUsersForSystemNotifications/',
                getAllUserIdsForSelectAll: BASECONFIG.apiUrl + '/api/SystemNotification/GetAllUserIDsForSelectAll',
                getRecipientIDsBySystemNotificationID: BASECONFIG.apiUrl + '/api/SystemNotification/GetRecipientIDsBySystemNotificationID/', 
                saveSystemNotificationRecipients: BASECONFIG.apiUrl + '/api/SystemNotification/SaveSystemNotificationRecipients',
                sendSystemNotificationToRecipients: BASECONFIG.apiUrl + '/api/SystemNotification/SendSystemNotificationToRecipients',
            },
            complaintConfiguration: {
                getAllComplaints: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/GetAllComplaints/',
                searchComplaints: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/SearchComplaints',
                getComplaintByID: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/GetComplaintByID/',
                getComplaintCommentsByComplaintId: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/GetComplaintCommentsByComplaintId',
                updateComplaintLocation: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/UpdateComplaintLocation',
                getFilesByComplaintCommentId: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/GetFilesByComplaintCommentID/',
                addNewComplaintComment: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/AddNewComplaintComment',
                addComplaintAnswer: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/AddComplaintAnswer',
                assignComplaintAndMakeItVisible: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/AssignComplaint',
                changeComplaintStatus: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/ChangeComplaintStatus/',
                uploadCommentFiles: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/UploadCommentFiles',
                uploadAnswerFiles: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/UploadAnswerFiles',
                SetComplaintCommentActive: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/SetComplaintCommentActive',
                SetComplaintCommentInappropriate: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/SetComplaintCommentInappropriate',
                downloadFile: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/DownloadFile',
                downloadAnswerFile: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/DownloadAnswerFile',
                deleteAnswerFile: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/DeleteAnswerFile/',
                getImagesByComplaintID: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/GetImagesByComplaintID/',
                updateComplaintStatus: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/UpdateComplaintStatus',
                deleteComplaintByID: BASECONFIG.apiUrl + '/api/ComplaintConfiguration/DeleteComplaintByID/',
            },
            notifications: {
                searchSendNotification: BASECONFIG.apiUrl + '/api/SendNotification/SearchNotifications',
                getSendNotificationByID: BASECONFIG.apiUrl + '/api/SendNotification/GetByID/',
                deleteSendNotification: BASECONFIG.apiUrl + '/api/SendNotification/Delete/',
                saveSendNotification: BASECONFIG.apiUrl + '/api/SendNotification/Save',
                saveSendNotificationUsersTelephoneNumber: BASECONFIG.apiUrl + '/api/SendNotification/SaveSendNotificationUsersTelephoneNumber',
                saveSendNotificationUsersEmail: BASECONFIG.apiUrl + '/api/SendNotification/SaveSendNotificationUsersEmail',
                sendNotificationToDevices: BASECONFIG.apiUrl + '/api/SendNotification/SaveSendNotificationDevice',
                getDevicesBySendNotificationID: BASECONFIG.apiUrl + '/api/SendNotification/GetDevicesBySendNotificationID',
                getUsersBySendNotificationID: BASECONFIG.apiUrl + '/api/SendNotification/GetUsersBySendNotificationID',
                sendNotificationNewsletter: BASECONFIG.apiUrl + '/api/SendNotification/SendNotificationNewsletter',
            },
            sessions: {
                search: BASECONFIG.apiUrl + '/api/Sessions/Search',
                getByID: BASECONFIG.apiUrl + '/api/Sessions/GetByID/',
                getBasicDataByID: BASECONFIG.apiUrl + '/api/Sessions/GetBasicDataByID/',
                save: BASECONFIG.apiUrl + '/api/Sessions/Save',
                sendSessionUpdatedNotification: BASECONFIG.apiUrl + '/api/Sessions/SendSessionUpdatedNotification',
                addNewSessionComment: BASECONFIG.apiUrl + '/api/Sessions/AddNewSessionComment',
                getSessionCommentsBySessionId: BASECONFIG.apiUrl + '/api/Sessions/GetSessionCommentsBySessionId',
                uploadSessionCommentFiles: BASECONFIG.apiUrl + '/api/Sessions/UploadSessionCommentFiles',
                downloadSessionCommentFile: BASECONFIG.apiUrl + '/api/Sessions/DownloadSessionCommentFile',
                setSessionCommentActive: BASECONFIG.apiUrl + '/api/Sessions/SetSessionCommentActive',
                setSessionCommentInappropriate: BASECONFIG.apiUrl + '/api/Sessions/SetSessionCommentInappropriate',
                getAgendasBySessionID: BASECONFIG.apiUrl + '/api/Sessions/GetAgendasBySessionID',
                getAgendaByID: BASECONFIG.apiUrl + '/api/Sessions/GetAgendaByID/',
                saveAgenda: BASECONFIG.apiUrl + '/api/Sessions/SaveAgenda',
                addNewAgendaComment: BASECONFIG.apiUrl + '/api/Sessions/AddNewAgendaComment',
                getAgendaCommentsByAgendaId: BASECONFIG.apiUrl + '/api/Sessions/GetAgendaCommentsByAgendaId/',
                uploadAgendaCommentFiles: BASECONFIG.apiUrl + '/api/Sessions/UploadAgendaCommentFiles',
                downloadAgendaCommentFile: BASECONFIG.apiUrl + '/api/Sessions/DownloadAgendaCommentFile',
                setAgendaCommentActive: BASECONFIG.apiUrl + '/api/Sessions/SetAgendaCommentActive',
                setAgendaCommentInappropriate: BASECONFIG.apiUrl + '/api/Sessions/SetAgendaCommentInappropriate',
                getAgendaDocumentsByAgendaID: BASECONFIG.apiUrl + '/api/Sessions/GetAgendaDocumentsByAgendaID',
                getAgendaDocumentByID: BASECONFIG.apiUrl + '/api/Sessions/GetAgendaDocumentByID/',
                saveAgendaDocument: BASECONFIG.apiUrl + '/api/Sessions/SaveAgendaDocument',
                downloadAgendaDocumentFile: BASECONFIG.apiUrl + '/api/Sessions/DownloadAgendaDocumentFile',
                deleteAgendaDocumentByID: BASECONFIG.apiUrl + '/api/Sessions/DeleteAgendaDocumentByID/',
                getNextAgendaItemNumberBySessionID: BASECONFIG.apiUrl + '/api/Sessions/GetNextAgendaItemNumberBySessionID/',
                getDocumentsBySessionID: BASECONFIG.apiUrl + '/api/Sessions/GetDocumentsBySessionID',
                getDocumentByID: BASECONFIG.apiUrl + '/api/Sessions/GetDocumentByID/',
                saveDocument: BASECONFIG.apiUrl + '/api/Sessions/SaveDocument',
                downloadFile: BASECONFIG.apiUrl + '/api/Sessions/DownloadDocumentFile',
                deleteSessionDocumentByID: BASECONFIG.apiUrl + '/api/Sessions/DeleteSessionDocumentByID/',
                deleteSessionByID: BASECONFIG.apiUrl + '/api/Sessions/DeleteSessionByID/',
                exportSessionData: BASECONFIG.apiUrl + '/api/Sessions/ExportSessionData',
                deleteAgendaByID: BASECONFIG.apiUrl + '/api/Sessions/DeleteAgendaByID/',
            },
            councilMembers: {
                getByID: BASECONFIG.apiUrl + '/api/CouncilMembers/GetByID/',
                getAll: BASECONFIG.apiUrl + '/api/CouncilMembers/GetAll/',
                getBasicDataByID: BASECONFIG.apiUrl + '/api/CouncilMembers/GetBasicDataByID/',
                save: BASECONFIG.apiUrl + '/api/CouncilMembers/Save',
                searchCouncilMembers: BASECONFIG.apiUrl + '/api/CouncilMembers/SearchCouncilMembers',
                getQuestionsByCouncilMemberID: BASECONFIG.apiUrl + '/api/CouncilMembers/GetQuestionsByCouncilMemberID',
                getQuestionByID: BASECONFIG.apiUrl + '/api/CouncilMembers/GetQuestionByID/',
                saveAnswer: BASECONFIG.apiUrl + '/api/CouncilMembers/SaveAnswer',
                deleteCouncilMemberByID: BASECONFIG.apiUrl + '/api/CouncilMembers/DeleteCouncilMemberByID/',
            },
            surveys: {
                search: BASECONFIG.apiUrl + '/api/Surveys/Search',
                getByID: BASECONFIG.apiUrl + '/api/Surveys/GetByID/',
                save: BASECONFIG.apiUrl + '/api/Surveys/Save',
                publish: BASECONFIG.apiUrl + '/api/Surveys/Publish',
                sendNotificationsToParticipants: BASECONFIG.apiUrl + '/api/Surveys/SendNotificationsToParticipants',
                getQuestionByID: BASECONFIG.apiUrl + '/api/Surveys/GetQuestionByID/',
                getQuestionsBySurveyID: BASECONFIG.apiUrl + '/api/Surveys/GetQuestionsBySurveyID',
                saveQuestion: BASECONFIG.apiUrl + '/api/Surveys/SaveQuestion',
                getNextQuestionOrdinalNumberBySurveyId: BASECONFIG.apiUrl + '/api/Surveys/GetNextQuestionOrdinalNumberBySurveyID/',
                saveProposedAnswer: BASECONFIG.apiUrl + '/api/Surveys/SaveProposedAnswer',
                getProposedAnswersByQuestionID: BASECONFIG.apiUrl + '/api/Surveys/GetProposedAnswersByQuestionID',
                getProposedAnswerByID: BASECONFIG.apiUrl + '/api/Surveys/GetProposedAnswerByID/',
                getProposedAnswerOptionsByQuestionID: BASECONFIG.apiUrl + '/api/Surveys/GetProposedAnswerOptionsByQuestionID',
                searchUsersForSurvey: BASECONFIG.apiUrl + '/api/Surveys/SearchUsersForSurvey',
                getAllUserIdsForSurveySelectAll: BASECONFIG.apiUrl + '/api/Surveys/GetAllUserIDsForSurveySelectAll',
                getParticipantsBySurveyID: BASECONFIG.apiUrl + '/api/Surveys/GetParticipantsBySurveyID',
                getParticipantIdsBySurveyID: BASECONFIG.apiUrl + '/api/Surveys/GetParticipantIDsBySurveyID/', 
                saveSurveyParticipants: BASECONFIG.apiUrl + '/api/Surveys/SaveSurveyParticipants',
                getSurveyBasicDataByID: BASECONFIG.apiUrl + '/api/Surveys/GetSurveyBasicDataByID/',
                deleteSurveyByID: BASECONFIG.apiUrl + '/api/Surveys/DeleteSurveyByID/',
                endSurvey: BASECONFIG.apiUrl + '/api/Surveys/endSurvey',
                deleteSurveyQuestionByID: BASECONFIG.apiUrl + '/api/Surveys/DeleteSurveyQuestionByID/',
                deleteProposedAnswerByID: BASECONFIG.apiUrl + '/api/Surveys/DeleteProposedAnswerByID/',
                downloadQRCode: BASECONFIG.apiUrl + '/api/Surveys/DownloadQRCode',
                updateStatusOnMaster: BASECONFIG.apiUrl + '/api/SurveyServices/UpdateStatusOnMaster',
                synchronizeSurvey: BASECONFIG.apiUrl + '/api/SurveyServices/SynchronizeSurvey'
            },
            administrativeProcedures: {
                searchLifeTopics: BASECONFIG.apiUrl + '/api/LifeTopics/Search',
                getLifeTopicById: BASECONFIG.apiUrl + '/api/LifeTopics/GetByID/',
                getSubtopicsByLifeTopicId: BASECONFIG.apiUrl + '/api/LifeTopics/GetSubtopicsByLifeTopicID',
                getAdministrativeProcedureById: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/GetAdministrativeProcedureDetailsByID/',
                getContactPersonById: BASECONFIG.apiUrl + '/api/GetContactPersonByID',
                getAdmProceduresByLifeSubtopicId: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/GetAdmProceduresByLifeSubtopicId',
                deleteAdmProcedureByID: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/DeleteAdmProcedureByID/',
                saveAdmProcedure: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/SaveAdmProcedure',
                downloadAmdProcedureDocument: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/DownloadAdministrativeProcedureFile',                
            }
        },
        infoSection: {
            getAllTexts: BASECONFIG.apiUrl + '/api/InfoSectionText/GetAll/',
            getAllDocuments: BASECONFIG.apiUrl + '/api/InfoSectionDocument/GetAll/',
            downloadFile: BASECONFIG.apiUrl + '/api/InfoSectionDocument/DownloadFile'
        },
        complaint: {
            getFiveLatest: BASECONFIG.apiUrl + '/api/Complaints/GetFiveLatest/',
            uploadImages: BASECONFIG.apiUrl + '/api/Complaints/UploadImage',
            saveComplaint: BASECONFIG.apiUrl + '/api/Complaints/SaveComplaint',
            getImagesByComplaintID: BASECONFIG.apiUrl + '/api/Complaints/GetImagesByComplaintID/',
            getAllComplaints: BASECONFIG.apiUrl + '/api/Complaints/SearchPublicComplaints/',
            getComplaintByID: BASECONFIG.apiUrl + '/api/Complaints/GetPublicComplaintByID/',
            getMyComplaintByID: BASECONFIG.apiUrl + '/api/Complaints/GetMyComplaintByID/',
            getAllComplaintsByUserID: BASECONFIG.apiUrl + '/api/Complaints/SearchComplaintsByUserID/',
            deleteComplaintImage: BASECONFIG.apiUrl + '/api/Complaints/DeleteComplaintImage/',
            getImagesIDByComplaintID: BASECONFIG.apiUrl + '/api/Complaints/GetImagesIDByComplaintID/',
            getImageByID: BASECONFIG.apiUrl + '/api/Complaints/GetImageByID/',
            downloadFile: BASECONFIG.apiUrl + '/api/Complaints/DownloadFile',
            addNewComplaintComment: BASECONFIG.apiUrl + '/api/Complaints/AddNewComplaintComment',
            uploadCommentFiles: BASECONFIG.apiUrl + '/api/Complaints/UploadCommentFiles',
            downloadAnswerFile: BASECONFIG.apiUrl + '/api/Complaints/DownloadAnswerFile',
            getNumberOfComplaintByCategory: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByCategory',
            getNumberOfComplaintByOrganization: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByOrganization',
            getNumberOfComplaintByStatus: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByStatus',
            getNumberOfComplaintsByMonth: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByMonth',
            getNumberOfComplaintsBYCategoryPerYear: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByCategoryPerYear',
            getNumberOfResolvedComplaintsBYCategoryByHourslangID: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfResolvedComplaintsByCategoryAndHours',
            getNumberOfComplaintsByGender: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByUserSex',
            getNumberOfComplaintsBySensitiveCategory: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsBySensitiveCategory',
            numberOfComplaintsByYearGroup: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByYearGroup',
            getNumberOfComplaintsByCategoryAndGender: BASECONFIG.apiUrl + '/api/Complaints/GetNumberOfComplaintsByCategoryAndGender',
            getOrgUnitsDropdownForComplaintConfiguration: BASECONFIG.apiUrl + '/api/OrganizationalUnit/GetOrgUnitsDropdownForComplaintAditionalAccessRight/',
            sendSystemNotificationEmailToAdmins: BASECONFIG.apiUrl + '/api/Complaints/SendSystemNotificationEmailToAdmins',
            sendSystemNotificationSMSToAdmins: BASECONFIG.apiUrl + '/api/Complaints/SendSystemNotificationSMSToAdmins',
        },
        shared: {
            getAllDocumentTypesForDropdown: BASECONFIG.apiUrl + '/api/AdminInfoSectionDocumentType/GetAllForDropdown/',
            getAllAgeStructuresForDropdown: BASECONFIG.apiUrl + '/api/AgeStructure/GetAllForDropdown/',
            getAllTerritoriesForDropdown: BASECONFIG.apiUrl + '/api/Territory/GetAllForDropdown/',
            getAllUnenploymentPeriodForDropdown: BASECONFIG.apiUrl + '/api/UnemploymentPeriod/GetAllForDropdown/',
            getAllMasterSurveySensitiveCategoriesForDropdown: BASECONFIG.apiUrl + '/api/MasterSurveySensitiveCategory/GetAllForDropdown/',
            getAllConfirmationRegistrationTypesForDropdown: BASECONFIG.apiUrl + '/api/ConfirmationRegistrationType/GetAllForDropdown/',
            getAllGendersForDropdown: BASECONFIG.apiUrl + '/api/Sex/GetAllForDropdown/',
            getAllSensitiveCategoriesForDropdown: BASECONFIG.apiUrl + '/api/SensitiveCategory/GetAllForDropdown/',
            getAllOrganizationalUnitsForDropdown: BASECONFIG.apiUrl + '/api/OrganizationalUnit/GetAllForDropdown/',
            getAllProfilesForDropdown: BASECONFIG.apiUrl + '/api/Profile/GetAllForDropdown/',
            getInternalProfilesForDropdown: BASECONFIG.apiUrl + '/api/Profile/GetInternalProfilesForDropdown/',
            getAllOrganizationalUnitFunctionsForDropdown: BASECONFIG.apiUrl + '/api/OrganizationalUnitFunction/GetAllForDropdown/',
            getAllLoginTypesForDropdown: BASECONFIG.apiUrl + '/api/LoginType/GetAllForDropdown/',
            getAllCategoriesForDropdown: BASECONFIG.apiUrl + '/api/Category/GetAllForDropdown/',
            getAllComplaintStatusesForDropdown: BASECONFIG.apiUrl + '/api/ComplaintStatus/GetAllForDropdown/',
            getAllLanguagesForDropdown: BASECONFIG.apiUrl + '/api/Language/GetAllForDropdown/',
            getAllConfigurationNotificationsForDropdown: BASECONFIG.apiUrl + '/api/ConfigurationNotification/GetAllForDropdown/',
            getAllDebateStatusesForDropdown: BASECONFIG.apiUrl + '/api/DebateStatus/GetAllForDropdown/',
            getAllDebateKindForDropdown: BASECONFIG.apiUrl + '/api/DebateKind/GetAllForDropdown/',
            getAllSessionStatusesForDropdown: BASECONFIG.apiUrl + '/api/SessionStatus/GetAllForDropdown/',
            getAllDebateSessionTypesForDropdown: BASECONFIG.apiUrl + '/api/DebateSessionType/GetAllForDropdown/',
            getAllPrivilegesForDropdown: BASECONFIG.apiUrl + '/api/Privileges/GetAllForDropdown/',
            getAllDebateCategoryForDropdown: BASECONFIG.apiUrl + '/api/DebateCategory/GetAllForDropdown/',
            getAllAgendaStatusesForDropdown: BASECONFIG.apiUrl + '/api/AgendaStatus/GetAllForDropdown/',
            getAllDebateSessionStatusesForDropdown: BASECONFIG.apiUrl + '/api/DebateSessionStatus/GetAllForDropdown/',
            getAllPoliticalPartiesForDropdown: BASECONFIG.apiUrl + '/api/PoliticalParty/GetAllForDropdown/',
            getAllConvocationsForDropdown: BASECONFIG.apiUrl + '/api/Convocation/GetAllForDropdown/',
            getAllOrganizationalUnitUsersForDropdown: BASECONFIG.apiUrl + '/api/Users/GetAllOrgUnitUsersForDropdown/',
            getAllCouncilMemberTypesForDropdown: BASECONFIG.apiUrl + '/api/CouncilMemberType/GetAllForDropdown/',
            getAllDebateTypesForDropdown: BASECONFIG.apiUrl + '/api/DebateType/GetAllForDropdown/',
            getAllSurveyTypesForDropdown: BASECONFIG.apiUrl + '/api/SurveyType/GetAllForDropdown/',
            getAllSurveyCategoriesForDropdown: BASECONFIG.apiUrl + '/api/SurveyCategory/GetAllForDropdown/',
            getAllSurveyParticipantTypesForDropdown: BASECONFIG.apiUrl + '/api/SurveyParticipantType/GetAllForDropdown/',
            getAllSurveyStatusesForDropdown: BASECONFIG.apiUrl + '/api/SurveyStatus/GetAllForDropdown/',
            getAllQuestionTypesForDropdown: BASECONFIG.apiUrl + '/api/QuestionType/GetAllForDropdown/',
            getAllAdmProcedureRefersToForDropdown: BASECONFIG.apiUrl + '/api/AdmProcedureRefersTo/GetAllForDropdown/',
            getAllAdmProcedureTypesForDropdown: BASECONFIG.apiUrl + '/api/AdmProcedureType/GetAllForDropdown/',
            getAllAdmProcedureStatusesForDropdown: BASECONFIG.apiUrl + '/api/AdmProcedureStatus/GetAllForDropdown/',
            getAllAdmProcedureSophisticationLevelsForDropdown: BASECONFIG.apiUrl + '/api/AdmProcedureSophisticationLevel/GetAllForDropdown/',
            getAllAdmProcedureOutputTypesForDropdown: BASECONFIG.apiUrl + '/api/AdmProcedureOutputType/GetAllForDropdown/',
            getAllAdmProcedureLegalRemediesForDropdown: BASECONFIG.apiUrl + '/api/LegalRemedy/GetAllForDropdown/',
            getAllDocumentDeliveryFormsForDropdown: BASECONFIG.apiUrl + '/api/DocumentDeliveryForm/GetAllForDropdown/',
            getAllAdmProcedureCategoriesForDropdown: BASECONFIG.apiUrl + '/api/AdministrativeProcedureCategory/GetAllForDropdown/',
        },
        userBasicData: {
            getByID: BASECONFIG.apiUrl + '/api/UserBasicData/GetByID/',
            changeUserBasicData: BASECONFIG.apiUrl + '/api/UserBasicData/ChangeUserBasicData',
            changePassword: BASECONFIG.apiUrl + '/api/UserBasicData/ChangePassword',
            deactivateUser: BASECONFIG.apiUrl + '/api/UserBasicData/DeactivateUser',
        },
        reports: {
            searchUsageStatistics: BASECONFIG.apiUrl + '/api/UsageStatistics/SearchUsageStatistics',
            exportUsageStatistics: BASECONFIG.apiUrl + '/api/UsageStatistics/ExportUsageStatistics',
            complaints: {
                searchComplaintsByAnswerTime: BASECONFIG.apiUrl + '/api/ComplaintListByAnswerTime/SearchComplaints',
                exportComplaintsByAnswerTime: BASECONFIG.apiUrl + '/api/ComplaintListByAnswerTime/ExportComplaintsByAnswerTime',
                searchComplaintsByTimePeriod: BASECONFIG.apiUrl + '/api/ComplaintListByTimePeriod/SearchComplaints',
                exportComplaintsByTimePeriod: BASECONFIG.apiUrl + '/api/ComplaintListByTimePeriod/ExportComplaintsByTimePeriod',
                searchComplaintsByCategoryAndStatus: BASECONFIG.apiUrl + '/api/ComplaintListByCategoryAndStatus/SearchComplaints',
                exportComplaintsByCategoryAndStatus: BASECONFIG.apiUrl + '/api/ComplaintListByCategoryAndStatus/ExportComplaintListByCategoryAndStatus',
                searchComplaintsByResolvingDate: BASECONFIG.apiUrl + '/api/ComplaintListByResolvingDate/SearchComplaints',
                exportComplaintsByResolvingDate: BASECONFIG.apiUrl + '/api/ComplaintListByResolvingDate/ExportComplaintsByResolvingDate',
                searchComplaintsByProfileData: BASECONFIG.apiUrl + '/api/ComplaintListByProfileData/SearchComplaints',
                exportComplaintsByProfileData: BASECONFIG.apiUrl + '/api/ComplaintListByProfileData/ExportComplaintsByProfileData',
                exportComplaintsDetailsById: BASECONFIG.apiUrl + '/api/ComplaintDetails/ExportComplaintDetailsByID',
            },
            sessions: {
                searchAgendaCommentsAndVotings: BASECONFIG.apiUrl + '/api/AgendaCommentsAndVotingsList/SearchAgendas',
                exportAgendaCommentsAndVotings: BASECONFIG.apiUrl + '/api/AgendaCommentsAndVotingsList/ExportAgendaCommentsAndVotingsList',
                searchSessionCommentsAndVotings: BASECONFIG.apiUrl + '/api/SessionCommentsAndVotingsList/SearchSessions',
                exportSessionCommentsAndVotings: BASECONFIG.apiUrl + '/api/SessionCommentsAndVotingsList/ExportSessionCommentsAndVotingsList',
                searchSessionAgendaAndDocuments: BASECONFIG.apiUrl + '/api/SessionAgendaAndDocumentsList/SearchSessions',
                exportSessionAgendasAndDocuments: BASECONFIG.apiUrl + '/api/SessionAgendaAndDocumentsList/ExportSessionAgendasAndDocumentsList',
                searchSessionDateAndDuration: BASECONFIG.apiUrl + '/api/SessionDateAndDurationList/SearchSessions',
                exportSessionDateAndDuration: BASECONFIG.apiUrl + '/api/SessionDateAndDurationList/ExportSessionDateAndDurationList',
                searchSessionData: BASECONFIG.apiUrl + '/api/SessionDataList/SearchSessions',
            },
            councilMembers: {
                searchCouncilMemberQuestionsAndAnswers: BASECONFIG.apiUrl + '/api/CouncilMemberQuestionsAndAnswers/SearchCouncilMembers',
                exportCouncilMemberQuestionsAndAnswers: BASECONFIG.apiUrl + '/api/CouncilMemberQuestionsAndAnswers/ExportCouncilMemberQuestionsAndAnswers',
                searchCouncilMemberQuestionsByStatus: BASECONFIG.apiUrl + '/api/CouncilMemberQuestionsByStatus/SearchCouncilMembers',
                exportCouncilMemberQuestionsByStatus: BASECONFIG.apiUrl + '/api/CouncilMemberQuestionsByStatus/ExportCouncilMemberQuestionsByStatus',
                searchCouncilMemberListByAnswerTime: BASECONFIG.apiUrl + '/api/CouncilMemberListByAnswerTime/SearchCouncilMembers',
                exportCouncilMemberListByAnswerTime: BASECONFIG.apiUrl + '/api/CouncilMemberListByAnswerTime/ExportCouncilMemberListByAnswerTime',
            },
            debates: {
                searchOfflineDebateSessionsByDebateId: BASECONFIG.apiUrl + '/api/SessionListWithNumberOfParticipants/SearchOfflineDebateSessions',
                exportSessionsWithNumberOfParticipants: BASECONFIG.apiUrl + '/api/SessionListWithNumberOfParticipants/ExportSessionsWithNumberOfParticipantsList',
                searchDebatesBycategory: BASECONFIG.apiUrl + '/api/DebateListByCategory/SearchDebatesByCategory',
                exportDebatesByCategory: BASECONFIG.apiUrl + '/api/DebateListByCategory/ExportDebatesByCategoryList',
                searchSessionTypes: BASECONFIG.apiUrl + '/api/SessionTypeListWithNumberOfParticipants/SearchSessionTypes',
                exportSessionTypesWithNumberOfParticipants: BASECONFIG.apiUrl + '/api/SessionTypeListWithNumberOfParticipants/ExportSessionTypes',
                searchLocations: BASECONFIG.apiUrl + '/api/LocationListWithSessionAndParticipantsNumber/SearchLocations',
                exportLocationsWithSessionAndParticipantsNumber: BASECONFIG.apiUrl + '/api/LocationListWithSessionAndParticipantsNumber/ExportSessionLocations',
                searchDebatesWithNumberOfParticipants: BASECONFIG.apiUrl + '/api/DebatesWithNumberOfParticipants/SearchDebatesWithNumberOfParticipants',
                exportDebatesWithNumberOfParticipants: BASECONFIG.apiUrl + '/api/DebatesWithNumberOfParticipants/ExportDebatesWithNumberOfParticipants',
                searchDebatesByDebateKind: BASECONFIG.apiUrl + '/api/DebateListByKind/SearchDebatesByDebateKind',
                exportDebatesByDebateKind: BASECONFIG.apiUrl + '/api/DebateListByKind/ExportDebatesByDebateKindList',
                searchDebatesByMonthAndType: BASECONFIG.apiUrl + '/api/DebatesByMonthAndType/SearchDebatesByMonthAndType',
                exportDebatesBMonthAndType: BASECONFIG.apiUrl + '/api/DebatesByMonthAndType/ExportDebatesByMonthAndType',
                searchDebateDiscussionCommentsByProfileData: BASECONFIG.apiUrl + '/api/DebateDiscussionCommentsByProfileData/SearchDebateDiscussionCommentsByProfileData',
                exportDebateDiscussionCommentsByProfileData: BASECONFIG.apiUrl + '/api/DebateDiscussionCommentsByProfileData/ExportDebateDiscussionCommentsByProfileDataList',
            },
        },
        sessions: {
            getFiveLatest: BASECONFIG.apiUrl + '/api/SessionsPublic/GetFiveLatest/',
            getAllForDropdown: BASECONFIG.apiUrl + '/api/SessionsPublic/GetAllForDropdown/',
            search: BASECONFIG.apiUrl + '/api/SessionsPublic/Search',
            getByID: BASECONFIG.apiUrl + '/api/SessionsPublic/GetByID/',
            addNewSessionComment: BASECONFIG.apiUrl + '/api/SessionsPublic/AddNewSessionComment',
            getSessionCommentsBySessionId: BASECONFIG.apiUrl + '/api/SessionsPublic/GetSessionCommentsBySessionId/',
            uploadSessionCommentFiles: BASECONFIG.apiUrl + '/api/SessionsPublic/UploadSessionCommentFiles',
            downloadSessionCommentFile: BASECONFIG.apiUrl + '/api/SessionsPublic/DownloadSessionCommentFile',
            getAgendasBySessionID: BASECONFIG.apiUrl + '/api/SessionsPublic/GetAgendasBySessionID',
            getAgendaByID: BASECONFIG.apiUrl + '/api/SessionsPublic/GetAgendaByID/',
            addNewAgendaComment: BASECONFIG.apiUrl + '/api/SessionsPublic/AddNewAgendaComment',
            getAgendaCommentsByAgendaId: BASECONFIG.apiUrl + '/api/SessionsPublic/GetAgendaCommentsByAgendaId/',
            uploadAgendaCommentFiles: BASECONFIG.apiUrl + '/api/SessionsPublic/UploadAgendaCommentFiles',
            downloadAgendaCommentFile: BASECONFIG.apiUrl + '/api/SessionsPublic/DownloadAgendaCommentFile',
            getAgendaDocumentsByAgendaID: BASECONFIG.apiUrl + '/api/SessionsPublic/GetAgendaDocumentsByAgendaID',
            downloadAgendaDocumentFile: BASECONFIG.apiUrl + '/api/SessionsPublic/DownloadAgendaDocumentFile',
            deleteAgendaDocumentByID: BASECONFIG.apiUrl + '/api/SessionsPublic/DeleteAgendaDocumentByID/',
            getDocumentsBySessionID: BASECONFIG.apiUrl + '/api/SessionsPublic/GetDocumentsBySessionID',
            downloadFile: BASECONFIG.apiUrl + '/api/SessionsPublic/DownloadDocumentFile',
            addNewAgendaVote: BASECONFIG.apiUrl + '/api/SessionsPublic/AddNewAgendaVote',
            getNumberOfSessionsByMonth: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfSessionsByMonth',
            getNumberOfSessionCommentsBySession: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfSessionCommentsBySession',
            getNumberOfVotingsBySession: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfVotingsBySession',
            getNumberOfAgendaCommentsByAgenda: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfAgendaCommentsByAgenda',
            getNumberOfVotingsByAgenda: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfVotingsByAgenda',
            getNumberOfAgendaAndDocumentsBySession: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfAgendaAndDocumentsBySession',
            getNumberOfCouncilMembersBySession: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfCouncilMembersBySession',
            getNumberOfAgendaByStatus: BASECONFIG.apiUrl + '/api/SessionsPublic/GetNumberOfAgendaByStatus',
        },
        offlineDebates: {
            searchofflineDebates: BASECONFIG.apiUrl + '/api/OfflineDebatesPublic/SearchOfflineDebates',
            getAllOfflineDebatesForDropdown: BASECONFIG.apiUrl + '/api/OfflineDebatesPublic/GetAllOfflineDebatesForDropdown/',
            getOfflineDebateById: BASECONFIG.apiUrl + '/api/OfflineDebatesPublic/GetByID/',
            downloadOfflineDebateFile: BASECONFIG.apiUrl + '/api/OfflineDebatesPublic/DownloadFile',
            downloadOfflineDebateSessionFile: BASECONFIG.apiUrl + '/api/OfflineDebatesPublic/DownloadDebateSessionFile',
            getOfflineDebateSessionDetail: BASECONFIG.apiUrl + '/api/OfflineDebatesPublic/GetSessionDetail/',
        },
        onlineDebates: {
            searchonlineDebates: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/SearchOnlineDebates',
            getOnlineDebateById: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/GetByID/',
            getOnlineDebateDiscussionById: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/GetDiscussionByID/',
            downloadOnlineDebateFile: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/DownloadFile',
            getOnlineDebateDiscussionCommentsByDiscussionId: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/GetDiscussionCommentsByDiscussionId/',
            downloadOnlineDebateDiscussionCommentFile: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/DownloadOnlineDebateDiscussionCommentFile',
            addNewOnlineDebateDiscussionComment: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/SaveOnlineDebateDiscussionComment',
            uploadOnlineDebateDiscussionCommentFiles: BASECONFIG.apiUrl + '/api/OnlineDebatesPublic/UploadOnlineDebateDiscussionCommentFiles',

        },
        debates: {
            getDebateById: BASECONFIG.apiUrl + '/api/Debates/GetByID/',
            getFiveLatestDebates: BASECONFIG.apiUrl + '/api/DebatesPublic/GetFiveLatestDebates',
        },
        debatesStatistic: {
            getNumberOfDebatesByKind: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfDebatesByKind/',
            getNumberOfDebatesByMonth: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfDebatesByMonth/',
            getNumberOfSessionByLocation: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfSessionByLocation/',
            getNumberOfCommentsByDebate: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfCommentsByDebate/',            
            getNumberOfCommentsBySensitiveCategory: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfCommentsBySensitiveCategory/', 
            getNumberOfCommentsByYearGroup: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfCommentsByYearGroup', 
            getNumberOfCommentsByGender: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfCommentsByGender/', 
            getNumberOfSessionsByDebate: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfSessionsByDebate/',
            getNumberOfDiscussionsByDebate: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfDiscussionsByDebate/',
            getNumberOfParticipantsByDebate: BASECONFIG.apiUrl + '/api/DebatesStatistic/GetNumberOfParticipantsByDebate/'
        },
        councilMembers: {
            search: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/Search',
            saveQuestion: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/SaveQuestion',
            getBasicDataByID: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetBasicDataByID/',
            getQuestionsByCouncilMemberID: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetQuestionsByCouncilMemberID',
            getCouncilMemberByUserID: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetCouncilMemberByUserID/',
            getOrganizationalUnitByUserID: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetCouncilMemberByUserID/test/',
            saveCouncilMember: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/SaveCouncilMember',
            getMyQuestionByID: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetMyQuestionByID/',
            saveMyAnswer: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/SaveMyAnswer',
            getFiveLatest: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetFiveLatest/',
            getNumberOfMemberQuestionsAndAnswers: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetNumberOfMemberQuestionsAndAnswers',
            getNumberOfMemberQuestionsByStatus: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetNumberOfQuestionsByStatus/',
            getMemberListByAnswerTime: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetMemberListByAnswerTime',
            getNumberOfQuestionsByGender: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetNumberOfQuestionsByGender',
            getNumberOfQuestionsBySensitiveCategory: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetNumberOfQuestionsBySensitiveCategory',
            getNumberOfQuestionsByYearGroup: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetNumberOfQuestionsByYearGroup',
            getNumberOfAnsweredAndNotAnsweredQuestions: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetNumberOfAnsweredAndNotAnsweredQuestions',
            getMemberListAverageAnswerTime: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetMemberListAverageAnswerTime',
            getCouncilMembersForCurrentConvocation: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetCouncilMembersForCurrentConvocation/',
            getCouncilMembersByConvocationID: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetCouncilMembersByConvocationID',
            GetMemberByMemberTypeId: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetMayorMemberIdByMemberTypeId',
            getMayorByMemberTypeIdAndConvocationId: BASECONFIG.apiUrl + '/api/CouncilMembersPublic/GetMayorByMemberTypeIdAndConvocationId',
        },
        organizationalUnitQuestions: {
            search: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/Search',
            getBasicDataByID: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetBasicDataByID',
            getQuestionsByOrganizationalUnitID: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetQuestionsByOrganizationalUnitID',
            saveQuestion: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/SaveQuestion',
            getOrganizationalUnitByUserID: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetOrganizationalUnitByUserID/',
            getMyQuestionByID: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/getMyQuestionByID/',
            saveMyAnswer: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/saveMyAnswer',
            GetNumberOfOrganizationalUnitQuestionsAndAnswers: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetNumberOfOrganizationalUnitQuestionsAndAnswers',
            getOrganizationalUnitListByAnswerTime: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetOrganizationalUnitListByAnswerTime',
            getNumberOfAnsweredAndNotAnsweredQuestions: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetNumberOfAnsweredAndNotAnsweredQuestions',
            getNumberOfQuestionsByGender: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetNumberOfQuestionsByGender',
            getNumberOfQuestionsBySensitiveCategory: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetNumberOfQuestionsBySensitiveCategory',
            getOrganizationalUnitListAverageAnswerTime: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetOrganizationalUnitListAverageAnswerTime',
            getNumberOfQuestionsByYearGroup: BASECONFIG.apiUrl + '/api/OrganizationalUnitQuestions/GetNumberOfQuestionsByYearGroup',
        },
        surveys: {
            search: BASECONFIG.apiUrl + '/api/Survey/Search',
            searchAll: BASECONFIG.apiUrl + '/api/Survey/SearchAll',
            getById: BASECONFIG.apiUrl + '/api/Survey/GetSurveyParticipantDataByID/',
            getSurveyBySurveyId: BASECONFIG.apiUrl + '/api/Survey/GetSurveyBySurveyID/',
            getQuestionById: BASECONFIG.apiUrl + '/api/Survey/GetQuestionBySurveyID/',
            getProposedAnswerOptionsByQuestionID: BASECONFIG.apiUrl + '/api/Survey/GetProposedAnswerOptionsByQuestionID',
            getProposedAnswersByQuestionID: BASECONFIG.apiUrl + '/api/Survey/GetProposedAnswersByQuestionID',
            getParticipantAnswerByQuestionID: BASECONFIG.apiUrl + '/api/Survey/GetParticipantAnswerByQuestionID',
            saveParticipantAnswers: BASECONFIG.apiUrl + '/api/Survey/SaveParticipantAnswer',
            saveParticipantDetails: BASECONFIG.apiUrl + '/api/Survey/SaveParticipantDetails',
            sendSms: BASECONFIG.apiUrl + '/api/Survey/SendSms',
            checkCode: BASECONFIG.apiUrl + '/api/Survey/CheckCode',
            addSurveyParticipant: BASECONFIG.apiUrl + '/api/Survey/AddSurveyParticipant',
            getAllSurveysForDropdown: BASECONFIG.apiUrl + '/api/Survey/GetAllSurveysForDropdown/',
            copySurvey: BASECONFIG.apiUrl + '/api/Survey/CopySurvey',
            swapQuestions: BASECONFIG.apiUrl + '/api/Surveys/SwapQuestions',
        },
        registerUser: BASECONFIG.apiUrl + '/api/Register/RegisterUser',
        registeredUserActivityByCode: BASECONFIG.apiUrl + '/api/Register/RegisteredUserActivityByCode',
        registeredUserSendNewCode: BASECONFIG.apiUrl + '/api/Register/RegisteredUserSendNewCode',
        registeredUserLogin: BASECONFIG.apiUrl + '/api/Login/ForRegisteredUser',
        anonymousUserLogin: BASECONFIG.apiUrl + '/api/Login/ForAnonymousUser',
        forgottenUsernamePassword: BASECONFIG.apiUrl + '/api/Login/ForgottenUsernamePassword',
        getAdditionalAccessRights: BASECONFIG.apiUrl + '/api/AccessRights/GetAdditionalAccessRights',
        subscribeToNewsletter: BASECONFIG.apiUrl + '/api/Newsletter/SubscribeToNewsletter',
        downloadUserManual: BASECONFIG.apiUrl + '/api/FooterLinks/DownloadUserManual',
        downloadTermsAndRequirements: BASECONFIG.apiUrl + '/api/FooterLinks/DownloadTermsAndRequirements',
        downloadPrivacyPolicy: BASECONFIG.apiUrl + '/api/FooterLinks/DownloadPrivacyPolicy',
        downloadHelpContacts: BASECONFIG.apiUrl + '/api/FooterLinks/DownloadHelpContacts',

        surveyResult: {
            getQuestionsBySurveyId: BASECONFIG.apiUrl + '/api/SurveyResults/GetQuestionsBySurveyId/',
            getAllSurveyParticipantForDropdown: BASECONFIG.apiUrl + '/api/SurveyResults/GetAllSurveyParticipantForDropdown/',
            getTextAnswersbyQuestionId: BASECONFIG.apiUrl + '/api/SurveyResults/GetTextAnswersbyQuestionId',
            getDateTimeAnswersByQuestionId: BASECONFIG.apiUrl + '/api/SurveyResults/GetDateTimeAnswersByQuestionId',
            getSingleChoiceAnswersByQuestionId: BASECONFIG.apiUrl + '/api/SurveyResults/GetSingleChoiceAnswersByQuestionId',
            getDemographicResultsSurveyById: BASECONFIG.apiUrl + '/api/SurveyResults/GetDemographicResultsSurveyById',
            getMultipleChoiceAnswersByQuestionId: BASECONFIG.apiUrl + '/api/SurveyResults/GetMultipleChoiceAnswersByQuestionId',
        },

        administrativeProcedures: {
            getAlleServicesCategories: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/GetAllAdministrativeProcedureCategories/',
            getServicesSubCategoriesByParentID: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/GetAdministrativeProcedureSubCategoriesByParentID/',
            getAdministrativeProceduresByCategoryID: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/GetAdministrativeProceduresByCategoryID/',
            getAdministrativeProcedureDetailsByID: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/GetAdministrativeProceduresDetailsByID/',
            getAdministrativeProceduresByName: BASECONFIG.apiUrl + '/api/AdministrativeProcedures/GetAdministrativeProceduresByName/',
        },
    },
    fileExtensions: {
        TEXT: ".txt",
        PDF: ".pdf",
        DOC: ".doc",
        DOCX: ".docx",
        EXCEL: ".xls",
        EXCELX: ".xlsx",
        PNG: ".png",
        JPG: ".jpg",
        JPEG: ".jpeg",
        GIF: ".gif",
        CSV: ".csv"
    },
    reportContentType: {
        PDF: "PDF",
        WORD: "WORD",
        EXCEL: "EXCEL"
    },
    loginTypes: {
        RegisteredUser: 1,
        AnonymousUser: 2
    },
    registrationFields: {
        Email: 1,
        SMS: 2,
        BirthYear: 3
        // Gender: 4,
        // SensitiveCategory: 5
    },
    confirmationRegistrationType: {
        Email: 1,
        SMS: 2
    },
    profileEnum: {
        Administrator: 1,
        AnonymousCitizen: 2,
        RegisteredCitizen: 3,
        ServiceProfile: 4,
        Office: 6,
        Manager: 7,
        OrgUnit: 8,
        Institution: 9,
        Company: 10,
        Community: 11,
        CouncilMember: 12,
        Mayor: 13,
        OfficeModerator: 14,
        Anketar: 15
    },
    memberType: {
        CouncilMember: 1,
        Mayor: 2,
        
    },

    complaintStatus: {
        Created: 1,
        Inappropriate: 2,
        Assigned: 3,
        Answered: 4,
        Resolved: 5
    },
    
    configurationNotification: {
        SMS: 1,
        Email: 2,
        Push: 3
    },
    complaintConfigurationEnum: {
        Broj_slika_koje_se_mogu_dodati_kod_prijave_problema: 1,
        Velicina_slike_izrazena_u_KB_koje_se_moze_dodati_kod_prijave_problema: 2
    },

    applicationType: 1, // 1 - Web application
    gpsAddressUrl: "https://nominatim.openstreetmap.org/reverse?",
    additionalAccessRightsEnum: {
        pravo_citanja_posljednjih_5_prituzbi: 1,
        modul_info_sekcija: 2,
        modul_pocetna: 3,
        sifrarnik_kategorije_puna_prava: 4,
        sifrarnik_organizacione_jedinice_puna_prava: 5,
        sifrarnik_funkcije_organizacionih_jedinica_puna_prava: 6,
        sifrarnik_osjetljive_kategorije_puna_prava: 8,
        sifrarnik_tipovi_dokumenata_puna_prava: 9,
        obavezna_polja_za_registraciju_Puna_prava : 10,
        odabir_vrste_prijave_Puna_prava : 11,
        konfiguracija_parametara_Puna_prava : 12,
        odabir_vrste_verifikacije_registracije_Puna_prava : 13,
        sistemske_notifikacije_Puna_prava : 14,
        lista_podnesenih_pritužbi_Puna_prava_Svi_nivoi : 15,
        lista_podnesenih_pritužbi_Puna_prava_Svoja_org_i_podređene_org: 16,
        sifrarnik_debate_session_type: 17,
        sifrarnik_pitanja_puna_prava: 18,
        sifrarnik_sazivi_puna_prava: 19,
        sifrarnik_politicke_partije_puna_prava: 20,
    },
    dataStatus:
    {
        Unchanged: 1,
        Created: 2,
        Updated: 3,
        Deleted: 4
    },
    agendaStatus:
    {
        InPreparation: 1,
        Active: 2,
        Finished: 3
    },
    sessionStatus:
    {
        InPreparation: 1,
        Active: 2,
        Finished: 3
    },
    privilegeEnum:
    {
        Anyone: 1,
        CreatorOnly: 2,
        Visitors: 3,
        RegisteredUsers: 4,
        Employees: 5
    },
    inputAnswerEnum:
    {
        Kroz_sistem: 1,
        Odgovorom_na_notifikaciju: 2,
        Odgovorom_na_notifikaciju_i_aktiviranjem_od_strane_administratora: 3,
        Kroz_sistem_od_strane_administratora: 4
    },
    debateTypes: {
        OnlineDebate: 1,
        OfflineDebate: 2
    },
    debateStatusEnum: {
        InPreparation: 1,
        Active: 2,
        Finished: 3
    },
    questionTypeEnum: {
        free_text_short: 1,
        free_text_long: 2,
        multiple_choice: 3,
        checkboxes: 4,
        dropdown: 5,
        linear_scale: 6,
        multiple_choice_grid: 7,
        checkbox_grid: 8,
        date: 9,
        time: 10
    },
    municipalityEnum: {
        //GRADOVI
            //RS
        grad_doboj: 1,
        grad_gradiska: 2,
        grad_prijedor: 3,
            //FBiH
        grad_bihac: 4,
        grad_cazin: 5,
        grad_tuzla: 6,//??
        grad_gracanica: 7,
        grad_gradacac: 8,

        //OPŠTINE
            //RS
        opstina_kozarska_dubica: 9,
        opstina_kostajnica: 10,
        opstina_teslic: 11,
        opstina_prnjavor: 12,

            //FBiH
        opstina_velika_kladusa: 13,
        opstina_sanski_most: 14,
        opstina_bosanska_krupa: 15,
        opstina_zepce: 16,
        opstina_kalesija: 17,
        opstina_tesanj: 18,

        //NOVE OPŠTINE

        //RS
        //GRADOVI
        grad_trebinje: 19,

        //OPSTINE
        opstina_celinac:20,
        opstina_gacko:21,
        opstina_istocno_novo_sarajevo:22,
        opstina_laktasi:23,
        opstina_mrkonjic_grad:24,
        opstina_samac:25,
        opstina_srbac:26,
        opstina_ljubinje:42,

        //FBIH

        //GRADOVI
        grad_mostar: 27,

        //OPSTINE
        opstina_bosanski_petrovac:28,
        opstina_busovaca:29,
        opstina_buzim:30,
        opstina_capljina:31,
        opstina_citluk:32,
        opstina_doboj_istok:33,
        opstina_ilijas:34,
        opstina_ljubuski:35,
        opstina_odzak:36,
        opstina_orasje:37,
        opstina_siroki_brijeg:38,
        opstina_tomislavgrad:39,
        opstina_vitez:40,
        opstina_trnovo:41,
        opstina_vogosca:43,
        opstina_kljuc:44,
    },

    surveyParticipantTypeEnum: {
        javna:1,
        odabranaGrupa: 2,
        interna:3
    },
    surveyFormEnum: {
        javneAnkete: 1,
        mojeAnkete: 2,
    },
    categoriesDropdownEnuum: {
        mayor: 1,
        council: 2,
        sector: 3
    },
    surveyStatusEnum: {
        kreirana: 1,
        u_toku: 2,
        zavrsena: 3,
        sinhronizovana: 4       
    },surveyProgressEnum: {
        nezapoceta: 1,
        zapoceta: 2,
        zavrsena: 3
    },
    surveyTypeEnum: {
        lokalna: 1,
        globalna: 2
    },
    systemNotificationEnum: {
        unos_nove_prituzbe: 1,
        prituzba_u_postupku: 2,
        odgovoreno_na_prituzbu: 3,
        prituzba_rijesena: 4,
        postavljeno_novo_pitanje: 5,
        sjednica_objavljena: 6,
        anketa_kreirana: 7,
        anketa_objavljena: 8,
        anketa_zavrsena: 9
    },
    pushNotificationTypeEnum: {
        MyComplaint: 1,
        PublicComplaint: 2,
        Notification: 3,
        InfoSection: 4,
        WebLink: 5,
        Survey: 6
    },
    imageMaxSizeInPixels: {
        height: 600,
        widht: 800,
        complaintImageMagnifie: 2
    }
}